import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import { AdminCmsAllData } from '../fragments';

export default gql`
query adminCmsAll($filters: AdminCmsContentFilters, $sortBy: AdminCmsContentOrder, $count: Int!, $page: Int) {
    adminCmsContents(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminCmsAllData
        }
    }
}
${PaginatorInfoFragment}
${AdminCmsAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminCmsAllContent.ts